import { userLoginCode, userLogin, userLogout } from '@/api/SSO/sso';
export default {
  namespaced: true,
  state: () => ({
    ssoEntrance: false
  }),
  mutations: {
    SETSSOENTRANCE(state, flag) {
      state.ssoEntrance = flag;
    }
  },
  actions: {
    // 二次登录
    // eslint-disable-next-line no-empty-pattern
    async userLoginCode({}, code) {
      localStorage.setItem('tempCode', code);
      localStorage.setItem('clientCode', code);
      const res = await userLoginCode({
        params: {
          code
        }
      });
      return res;
    },
    // 登录
    // eslint-disable-next-line no-empty-pattern
    async userLogin({}, href) {
      console.log('href', href);
      localStorage.setItem('tempCode', 'code');
      const res = await userLogin({
        params: {
          href
        }
      });
      return res;
    },
    // 登出
    // eslint-disable-next-line no-empty-pattern
    async userLogout({}, href) {
      const res = await userLogout({
        params: {
          href
        }
      });
      return res;
    }
  }
};